/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { CapitolTradeTransaction } from '../models/capitol-trade-transaction';
import { SchedulerAudit } from '../models/scheduler-audit';
@Injectable({
  providedIn: 'root',
})
class CapitolTradesService extends __BaseService {
  static readonly getCapitolTradesTransactionsPath = '/capitol-trades';
  static readonly setEnableStatusOfExport24Path = '/status-24-export/enable';
  static readonly setDisableStatusOfExport24Path = '/status-24-export/disable';
  static readonly getCurrentStatusOfExport24Path = '/status-24-export/get-24-export-status';
  static readonly setEnableStatusOfExportPath = '/price-maintenance/enable';
  static readonly setDisableStatusOfExportPath = '/price-maintenance/disable';
  static readonly getCurrentStatusOfExportPath = '/price-maintenance/get-status';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Get the transactions data for capitol trades
   */
  getCapitolTradesTransactionsResponse(): __Observable<__StrictHttpResponse<Array<CapitolTradeTransaction>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/capitol-trades`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CapitolTradeTransaction>>;
      })
    );
  }
  /**
   * @return Get the transactions data for capitol trades
   */
  getCapitolTradesTransactions(): __Observable<Array<CapitolTradeTransaction>> {
    return this.getCapitolTradesTransactionsResponse().pipe(
      __map(_r => _r.body as Array<CapitolTradeTransaction>)
    );
  }

  /**
   * @return Set the status of Export24 to enable
   */
  setEnableStatusOfExport24Response(): __Observable<__StrictHttpResponse<SchedulerAudit>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/status-24-export/enable`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SchedulerAudit>;
      })
    );
  }
  /**
   * @return Set the status of Export24 to enable
   */
  setEnableStatusOfExport24(): __Observable<SchedulerAudit> {
    return this.setEnableStatusOfExport24Response().pipe(
      __map(_r => _r.body as SchedulerAudit)
    );
  }

  /**
   * @return Set the status of Export24 to disable
   */
  setDisableStatusOfExport24Response(): __Observable<__StrictHttpResponse<SchedulerAudit>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/status-24-export/disable`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SchedulerAudit>;
      })
    );
  }
  /**
   * @return Set the status of Export24 to disable
   */
  setDisableStatusOfExport24(): __Observable<SchedulerAudit> {
    return this.setDisableStatusOfExport24Response().pipe(
      __map(_r => _r.body as SchedulerAudit)
    );
  }

  /**
   * @return Set the status of Export24 to disable
   */
  getCurrentStatusOfExport24Response(): __Observable<__StrictHttpResponse<SchedulerAudit>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/status-24-export/get-24-export-status`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SchedulerAudit>;
      })
    );
  }
  /**
   * @return Set the status of Export24 to disable
   */
  getCurrentStatusOfExport24(): __Observable<SchedulerAudit> {
    return this.getCurrentStatusOfExport24Response().pipe(
      __map(_r => _r.body as SchedulerAudit)
    );
  }

  /**
   * @return Set the status of Export24 to enable
   */
  setEnableStatusOfExportResponse(): __Observable<__StrictHttpResponse<SchedulerAudit>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/price-maintenance/enable`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SchedulerAudit>;
      })
    );
  }
  /**
   * @return Set the status of Export24 to enable
   */
  setEnableStatusOfExport(): __Observable<SchedulerAudit> {
    return this.setEnableStatusOfExportResponse().pipe(
      __map(_r => _r.body as SchedulerAudit)
    );
  }

  /**
   * @return Set the status of Export24 to disable
   */
  setDisableStatusOfExportResponse(): __Observable<__StrictHttpResponse<SchedulerAudit>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/price-maintenance/disable`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SchedulerAudit>;
      })
    );
  }
  /**
   * @return Set the status of Export24 to disable
   */
  setDisableStatusOfExport(): __Observable<SchedulerAudit> {
    return this.setDisableStatusOfExportResponse().pipe(
      __map(_r => _r.body as SchedulerAudit)
    );
  }

  /**
   * @return Set the status of Export24 to disable
   */
  getCurrentStatusOfExportResponse(): __Observable<__StrictHttpResponse<SchedulerAudit>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/price-maintenance/get-status`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SchedulerAudit>;
      })
    );
  }
  /**
   * @return Set the status of Export24 to disable
   */
  getCurrentStatusOfExport(): __Observable<SchedulerAudit> {
    return this.getCurrentStatusOfExportResponse().pipe(
      __map(_r => _r.body as SchedulerAudit)
    );
  }
}

module CapitolTradesService {
}

export { CapitolTradesService }
